import { render, staticRenderFns } from "./OrgsTable.vue?vue&type=template&id=021d7598&"
import script from "./OrgsTable.vue?vue&type=script&lang=js&"
export * from "./OrgsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports